import React from 'react';

export const TIER_STYLE = {
  High: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  Potential: 'bg-amber-50 text-amber-700 border-amber-200',
  Adjacent: 'bg-slate-100 text-slate-600 border-slate-200',
};

export const TIER_LABEL = {
  High: 'High Relevance',
  Potential: 'Potential Relevance',
  Adjacent: 'Adjacent Opportunities',
};

export const TIER_HINT = {
  High: 'Direct product/platform fit + evidence supporting partnering or manufacturing fit',
  Potential: 'Strong fit but partnering / manufacturing needs verification',
  Adjacent: 'Potentially useful related technology — insufficient evidence of core fit',
};

const EVIDENCE_STYLE = {
  Confirmed: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  Probable: 'bg-sky-50 text-sky-700 border-sky-200',
  Adjacent: 'bg-slate-100 text-slate-600 border-slate-200',
  'Historically partnered': 'bg-sky-50 text-sky-700 border-sky-200',
  'External manufacturing': 'bg-amber-50 text-amber-700 border-amber-200',
  'Apparently unavailable': 'bg-rose-50 text-rose-700 border-rose-200',
  Unknown: 'bg-slate-100 text-slate-500 border-slate-200',
  'Not identified': 'bg-slate-100 text-slate-500 border-slate-200',
  'Needs verification': 'bg-amber-50 text-amber-700 border-amber-200',
};

export const Pill = ({ value, className = '', testId }) => (
  <span
    data-testid={testId}
    className={`inline-flex items-center text-[10px] font-semibold px-1.5 py-0.5 rounded border whitespace-nowrap ${EVIDENCE_STYLE[value] || 'bg-slate-100 text-slate-600 border-slate-200'} ${className}`}
  >
    {value || 'Not identified'}
  </span>
);

export const MatchTypePill = ({ value }) => {
  const m = {
    Product: 'bg-violet-50 text-violet-700 border-violet-200',
    Platform: 'bg-indigo-50 text-indigo-700 border-indigo-200',
    Both: 'bg-fuchsia-50 text-fuchsia-700 border-fuchsia-200',
  };
  const label = value === 'Both' ? 'Product + Platform' : value === 'Product' ? 'Product / Asset' : value === 'Platform' ? 'Technology / Platform' : 'Unclear';
  return (
    <span className={`inline-flex items-center text-[10px] font-semibold px-1.5 py-0.5 rounded border whitespace-nowrap ${m[value] || 'bg-slate-100 text-slate-500 border-slate-200'}`}>
      {label}
    </span>
  );
};

export const CrmFlags = ({ crm }) => {
  if (!crm) return null;
  const flags = [];
  if (crm.dnc) flags.push(['Do-not-contact', 'bg-rose-100 text-rose-800 border-rose-200']);
  if (crm.declined) flags.push(['Previous decline', 'bg-rose-50 text-rose-700 border-rose-200']);
  if (crm.under_evaluation) flags.push(['Under evaluation', 'bg-sky-50 text-sky-700 border-sky-200']);
  if (crm.contacted) flags.push([`Contacted ×${crm.contacted}${crm.last_contact ? ` · ${crm.last_contact}` : ''}`, 'bg-amber-50 text-amber-700 border-amber-200']);
  if (crm.relationship) flags.push([crm.relationship, 'bg-emerald-50 text-emerald-700 border-emerald-200']);
  (crm.other_mandates || []).forEach(m => flags.push([`Active in: ${m}`, 'bg-orange-50 text-orange-700 border-orange-200']));
  if (!flags.length) flags.push(['Not contacted', 'bg-slate-50 text-slate-500 border-slate-200']);
  return (
    <div className="flex flex-wrap gap-1">
      {flags.map(([t, c], i) => (
        <span key={i} className={`inline-flex text-[10px] font-medium px-1.5 py-0.5 rounded border ${c}`}>{t}</span>
      ))}
    </div>
  );
};
